import defaultApi from "../../services/api/DefaultApi";

const actions = {
  async getTranslate({ commit }) {
    let err, response;
    try {
      [err, response] = await defaultApi.getTranslate();
      if (!err) {
        commit("SET_TRANSLATE", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export default actions;
